import { Box, Skeleton } from '@mui/material'
import { HeadingProps } from '../Heading'
import { TextProps } from '../Text'
import { CardDesc, CardHeading } from './ItemCard.styles'

const headingLines = ['85%', '50%', '40%', '60%', '75%']
const descLines = ['95%', '80%', '90%', '60%', '45%']

export const SkeletonHeading = (props: Partial<HeadingProps>) => {
  const { size, lines, variant } = props
  const linesCount = Array.from(
    { length: lines || 1 },
    (_, i) => headingLines[i] || '100%'
  )
  return (
    <CardHeading size={size} variant={variant} sx={{ marginBottom: '-2px' }}>
      {linesCount.map((val, index) => {
        const key = `line-${index}`
        return <Skeleton key={key} width={val} />
      })}
    </CardHeading>
  )
}

export const SkeletonDesc = (props: Partial<TextProps>) => {
  const { size, lines } = props
  const linesCount = Array.from(
    { length: lines || 2 },
    (_, i) => descLines[i] || '100%'
  )
  return (
    <CardDesc size={size} sx={{ marginBottom: '-2px' }}>
      {linesCount.map((val, index) => {
        const key = `line-${index}`
        return <Skeleton key={key} width={val} />
      })}
    </CardDesc>
  )
}

export const SkeletonPrice = (props: Partial<TextProps>) => {
  const { size } = props
  return (
    <CardDesc size={size} sx={{ marginBottom: '-2px' }}>
      <Skeleton width={90} />
    </CardDesc>
  )
}

export const SkeletonTags = () => {
  return (
    <Box sx={{ display: 'flex', gap: '4px', height: '12px' }}>
      <Skeleton width="100%" height={18} sx={{ maxWidth: '42px' }} />
      <Skeleton width="100%" height={18} sx={{ maxWidth: '40px' }} />
      <Skeleton width="100%" height={18} sx={{ maxWidth: '56px' }} />
    </Box>
  )
}
